import { render, staticRenderFns } from "./SummaryInsight.vue?vue&type=template&id=705abd10&scoped=true"
import script from "./SummaryInsight.vue?vue&type=script&lang=js"
export * from "./SummaryInsight.vue?vue&type=script&lang=js"
import style0 from "./SummaryInsight.vue?vue&type=style&index=0&id=705abd10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705abd10",
  null
  
)

export default component.exports